import React from 'react';
import { motion, useScroll, useTransform } from 'motion/react';
import styles from './Nav.module.css';

function Nav() {
  const { scrollY } = useScroll();
  const navBg = useTransform(
    scrollY,
    [0, 80],
    ['rgba(9,9,11,0)', 'rgba(9,9,11,0.85)']
  );
  const navBlur = useTransform(
    scrollY,
    [0, 80],
    ['blur(0px)', 'blur(12px)']
  );

  return (
    <motion.nav
      className={styles.nav}
      style={{ backgroundColor: navBg, backdropFilter: navBlur, WebkitBackdropFilter: navBlur }}
    >
      <a href="#home" className={styles.wordmark}>
        Balaram.
      </a>
      
      <div className={styles.links}>
        <a href="#home" className={styles.navLink}>Home</a>
        <a href="#about" className={styles.navLink}>About</a>
        <a href="#skills" className={styles.navLink}>Skills</a>
        <a href="#projects" className={styles.navLink}>Projects</a>
      </div>

    </motion.nav>
  );
}

export default Nav;
